<template>
  <div>
    <div style="background-color: #fff; padding-bottom: 30px;">
      <!-- <mdb-container>
        <mdb-row>
          <div class="progress__container">
            <img src="/img/progress/W02.svg" style="width: 100%; height: auto;" alt />
          </div>
        </mdb-row>
      </mdb-container> -->
    </div>
    <div style="background-color: #f7f7f7;" class="mt-1 pt-1 cardClass">
      <mdb-container
        style="max-width: 97% !important; padding-bottom: 0rem; background-color: #fff; -webkit-box-shadow: 0px 6px 15px 0px rgba(0,0,0,0.34); -moz-box-shadow: 0px 6px 15px 0px rgba(0,0,0,0.34); box-shadow: 0px 6px 15px 0px rgba(0,0,0,0.34);"
        class="mt-5"
      >
      <div class="text-justify" style="padding: 5rem; font-family: 'Open Sans'; font-size:14px;" >
        <mdb-row class="pr-5" style="display: flex; float: right;">
          
          <mdb-col md="1" class="text-right" style="margin-left: 24%;">
            <p
              style="font-size: 30px; cursor: pointer; color: #000; font-weight: 700;"
              @click="$router.push('/home')"
            >x</p>
          </mdb-col>
        </mdb-row>
          <span style="font-family: 'Josefin Sans'; font-size:20px; color: #dc7134; font-weight: 600;">Datos y documentos necesarios para realizar el trámite de admisión</span>
          <p style="font-weight: 700;">Para tu registro en el sistema</p>
          <p>
              <ul>
                  <li>Correo electrónico</li>
              </ul>
          </p>
          <p style="font-weight: 700;">Para crear tu solicitud</p>
          <p>
              <ul>
                  <li>Foto de reostro instantánea</li>
                  <li>Estado civil</li>
                  <li>Archivo PDF de su Acta de nacimiento actualizada</li>
                  <li>Archivo PDF de su CURP actualizada</li>
                  <li>Archivo PDF de su identificación oficial INE/Pasaporte</li>
                  <li>De la CURP y de la indentificación oficial se obtiene
                      <ul>
                          <li>Nombre(s)</li>
                          <li>Apellido paterno</li>
                          <li>Apellido materno</li>
                          <li>Fecha de nacimiento</li>
                          <li>Entidad de nacimiento</li>
                          <li>Sexo</li>
                      </ul>
                  </li>
                  <li>Datos laborales:
                      <ul>
                          <li>Empresa o lugar de trabajo</li>
                          <li>Profesión</li>
                          <li>Puesto que desempeña</li>
                          <li>Giro de la empresa</li>
                          <li>Teléfono de la empresa</li>
                          <li>Archivo PDF de la Constancia fiscal de la empresa</li>
                      </ul>
                  </li>
                  <li>Una recomendación de un <span style="font-weight: 700;">Socio Titular</span>
                      <ul>
                          <li>Nombre del socio</li>
                          <li>Apellido paterno del socio</li>
                          <li>Apellido materno del socio</li>
                          <li>Teléfono del socio</li>
                          <li>Número de acción del socio</li>
                          <li>Correo electrónico del socio</li>
                      </ul>
                  </li>
                  <li> <span style="font-weight: 700;">De tu ex pareja si tu estado civil es DIVORCIADO</span>
                    <ul>
                      <li>Nombre(s)</li>
                      <li>Apellido paterno</li>
                      <li>Apellido paterno</li>
                    </ul>
                  </li>
                  <li> <span style="font-weight: 700;">De tu Cónyuge si tu estado civil es CASADO</span>
                    <ul>
                      <li>Foto de rostro instantánea</li>
                      <li>Archivo PDF de su Acta de nacimiento actualizada</li>
                      <li>Archivo PDF de su CURP actualizada</li>
                      <li>Archivo PDF de su identificación oficial INE/Pasaporte</li>
                      <li>De la CURP y la identificación oficial se obtiene
                        <ul>
                      <li>Nombre(s)</li>
                      <li>Apellido paterno</li>
                      <li>Apellido paterno</li>
                      <li>Fecha de nacimiento</li>
                      <li>Entidad de nacimiento</li>
                      <li>Sexo</li>
                    </ul>
                      </li>
                      <li>
                        Datos laborales:
                        <ul>
                    <li>Empresa o lugar de trabajo</li>
                          <li>Profesión</li>
                          <li>Puesto que desempeña</li>
                          <li>Giro de la empresa</li>
                          <li>Teléfono de la empresa</li>
                          <li>Archivo PDF de la Constancia fiscal de la empresa</li>
                      </ul>
                      </li>
                    </ul>
                  </li>
              </ul>
          </p>
           <p style="font-weight: 700;">Para realizar el pago por tu trámite de admisión</p>
            <p>
                <ul>
                  <li>Nombre del tarjetahabiente</li>
                  <li>Número de tarjeta</li>
                  <li>Teléfono del dueño de la tarjeta</li>
                  <li>Mes y año de vencimiento</li>
                </ul>

                <ul>
                  <li><strong style="font-weight: 700;">Como propietario</strong>
                    <ul>
                      <li>Si deseas adquirir una casa como venta nueva
                        <ul>
                          <li>Domicilio de la casa</li>
                          <li>Número de terreno</li>
                        </ul>
                      </li>
                      <li>Si deseas adquirir una casa como traspaso
                        <ul>
                          <li>Domicilio de la casa</li>
                          <li>Número de terreno</li>
                          <li>Nombre completo del propietario anterior</li>
                          <li>Archivo PDF de las Escrituras o Convenio de adhesión</li>
                          <li>Archivo PDF del Pago del Predial del año actual</li>
                        </ul>
                      </li>
                      <li>Si deseas adquirir un terreno como venta nueva
                        <ul>
                          <li>Número de terreno</li>
                        </ul>
                      </li>
                      <li>Si deseas adquirir un terreno como traspaso
                        <ul>
                          <li>Número de terreno</li>
                          <li>Nombre completo del propietario anterior</li>
                          <li>Archivo PDF de las Escrituras o Convenio de adhesión</li>
                          <li>Archivo PDF del Pago del Predial del año actual</li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                  <li><strong style="font-weight: 700;">Como usufructuario</strong>
                    <ul>
                      <li>Si deseas rentar una casa
                        <ul>
                          <li>Nombre completo del propietario de la casa</li>
                          <li>Domicilio de la casa a rentar</li>
                        </ul>
                      </li>
                      <li>Si deseas rentar una acción
                        <ul>
                          <li>Nombre completo del propietario de la acción</li>
                          <li>Número de la acción</li>
                        </ul>
                      </li>
                      <li>Si deseas rentar una casa y una acción
                        <ul>
                          <li>Nombre completo del propietario de la casa</li>
                          <li>Domicilio de la casa</li>
                          <li>Número de acción a rentar</li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>
            </p>
<!-- 
          <p style="font-weight: 700;">Si deseas adquirir una casa o un terreno como tipo de venta Traspaso</p>
              <p>  
                <ul>
              
                </ul>
                </p> -->

         
         


          <p style="font-weight: 700;">Tuyos al ser ACEPTADA tu solicitud</p>
          <p>
            <ul>
              <li>Domicilio
                <ul>
                  <li>Estado</li>
                  <li>Ciudad</li>
                  <li>Código Postal</li>
                  <li>Colonia</li>
                  <li>Calle</li>
                  <li>Número Int.</li>
                  <li>Número Ext.</li>
                  <li>Archivo PDF del comprobante de domicilio</li>
                </ul>
              </li>
              <li>Datos del contacto
                <ul>
                  <li>Teléfono celular</li>
                  <li>Otro teléfono</li>
                </ul>
              </li>
              <li>
                Datos de emergencia
                <ul>
                  <li>Nombre(s)</li>
                  <li>Apellido paterno</li>
                  <li>Apellido materno</li>
                  <li>Parentesco</li>
                  <li>Número de teléfono</li>
                </ul>
              </li>
              <li>Datos de facturación
                <ul>
                  <li>Nombre o razón social</li>
                  <li>RFC</li>
                  <li>Domicilio de facturación
                    <ul>
                      <li>Estado</li>
                  <li>Ciudad</li>
                  <li>Código Postal</li>
                  <li>Colonia</li>
                  <li>Calle</li>
                  <li>Número Int.</li>
                  <li>Número Ext.</li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>Autos
                <ul>
                  <li>Marca</li>
                  <li>Modelo</li>
                  <li>Año</li>
                  <li>Color</li>
                  <li>Placa</li>
                  <li>Archivo PDF de la factura</li>
                </ul>
              </li>
              <li><span style="font-weight: 700;">De tu Cónyuge al ser ACEPTADA la solicitud</span>
                <ul>
                  <li>Domicilio
                    <ul>
                       <li>Estado</li>
                  <li>Ciudad</li>
                  <li>Código Postal</li>
                  <li>Colonia</li>
                  <li>Calle</li>
                  <li>Número Int.</li>
                  <li>Número Ext.</li>
                  <li>Archivo PDF del comprobante de domicilio</li>
                    </ul>
                  </li>
                  <li>Datos de contacto
                    <ul>
                      <li>Teléfono celular</li>
                      <li>Otro teléfono</li>
                    </ul>
                  </li>
                  <li> Datos de emergencia
                <ul>
                  <li>Nombre(s)</li>
                  <li>Apellido paterno</li>
                  <li>Apellido materno</li>
                  <li>Parentesco</li>
                  <li>Número de teléfono</li>
                </ul>
                </li>
            
                </ul>
              </li>
              <li>
                <span style="font-weight: 700;">De tus Hij@s al ser ACEPTADA la solicitud</span>
                <ul>
                  <li> <span style="font-weight: 700;">Para hij@s menores de edad:</span>
                  <ul>
                    <li>Foto de rostro instantánea</li>
                    <li>Archivo PDF de su Acta de nacimiento actualizada</li>
                    <li>Archivo PDF de su CURP</li>
                    <li>De la CURP se obtiene
                      <ul>
                        <li>Nombre(s)</li>
                      <li>Apellido paterno</li>
                      <li>Apellido paterno</li>
                      <li>Fecha de nacimiento</li>
                      <li>Entidad de nacimiento</li>
                      <li>Sexo</li>

                      </ul>
                    </li>
                    <li>Domicilio
                      <ul>
                         <li>Estado</li>
                  <li>Ciudad</li>
                  <li>Código Postal</li>
                  <li>Colonia</li>
                  <li>Calle</li>
                  <li>Número Int.</li>
                  <li>Número Ext.</li>
                  <li>Archivo PDF del comprobante de domicilio</li>

                      </ul>
                    </li>
                    <li>Datos de contacto
                    <ul>
                      <li>Teléfono celular</li>
                      <li>Otro teléfono</li>
                    </ul>
                  </li>
                  <li> Datos de emergencia
                <ul>
                  <li>Nombre(s)</li>
                  <li>Apellido paterno</li>
                  <li>Apellido materno</li>
                  <li>Parentesco</li>
                  <li>Número de teléfono</li>
                </ul>
                </li>

                  </ul>
                  </li>
                  <li> <span style="font-weight: 700;">Para hij@s mayores de edad:</span>
                  <ul>
                    <li>Foto de rostro instantánea</li>
                    <li>Archivo PDF de su Acta de nacimiento actualizada</li>
                    <li>Archivo PDF de su CURP</li>
                    <li>De la CURP se obtiene
                      <ul>
                        <li>Nombre(s)</li>
                      <li>Apellido paterno</li>
                      <li>Apellido paterno</li>
                      <li>Fecha de nacimiento</li>
                      <li>Entidad de nacimiento</li>
                      <li>Sexo</li>

                      </ul>
                    </li>
                    <li>Domicilio
                      <ul>
                         <li>Estado</li>
                  <li>Ciudad</li>
                  <li>Código Postal</li>
                  <li>Colonia</li>
                  <li>Calle</li>
                  <li>Número Int.</li>
                  <li>Número Ext.</li>
                  <li>Archivo PDF del comprobante de domicilio</li>

                      </ul>
                    </li>
                    <li>Datos laborales:
                      <ul>
                        <li>Empresa o lugar de trabajo</li>
                          <li>Profesión</li>
                          <li>Puesto que desempeña</li>
                          <li>Giro de la empresa</li>
                          <li>Teléfono de la empresa</li>
                          <li>Archivo PDF de la Constancia fiscal de la empresa</li>
                      </ul>
                  </li>
                    <li>Datos de contacto
                    <ul>
                      <li>Teléfono celular</li>
                      <li>Otro teléfono</li>
                    </ul>
                  </li>
                  <li> Datos de emergencia
                <ul>
                  <li>Nombre(s)</li>
                  <li>Apellido paterno</li>
                  <li>Apellido materno</li>
                  <li>Parentesco</li>
                  <li>Número de teléfono</li>
                </ul>
                </li>

                  </ul>
                  </li>
                  
                </ul>
              </li>
              <!-- <li> <span style="font-weight: 700;">Si deseas adquirir una casa o un terreno</span>
                <ul>
                  <li>Archivo PDF de las Escrituras o convenio de adhesión</li>
                  <li>Archivo PDF del pago del predial</li>
                </ul>
              </li>
              <li>
                <span style="font-weight: 700;">Para realizar el pago por tu trámite de admisión</span>
                <ul>
                  <li>Nombre del tarjetahabiente</li>
                  <li>Número de tarjeta</li>
                  <li>Teléfono del dueño de la tarjeta</li>
                  <li>Mes y año de vencimiento</li>
                  <li>CVV/CVC</li>
                </ul>
              </li> -->
            </ul>
          </p>
         

      
      </div>
         
      </mdb-container>
      
    </div>
    <Footer style="bottom: auto;" />
  </div>

</template>


<script>
import { mdbContainer, mdbRow, mdbCol } from "mdbvue";
import Footer from "../core/Footer";

export default {
  name: "documentsRequest",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    Footer,
  },
};
</script>

<style>
</style>